export default __webpack_public_path__ + "static/media/ASHT.1850e7b9.png";